import { get } from 'lodash';

const root = state =>
  get(state, 'TruckRouteState.manageTruckRouteScheduleList');

export const getTruckRouteScheduleList = state =>
  get(root(state), 'truckRouteScheduleListData', []);
export const getTruckRouteScheduleDataLoading = state =>
  get(root(state), 'truckRouteScheduleDataLoading', false);
export const getTruckRouteScheduleDataLoadingError = state =>
  get(root(state), 'truckRouteScheduleDataLoadingError', null);
export const getDeleteTruckRouteScheduleSuccess = state =>
  get(root(state), 'deleteTruckRouteScheduleSuccess', null);
export const getDeleteTruckRouteScheduleLoading = state =>
  get(root(state), 'deleteTruckRouteScheduleLoading', false);
export const getDeleteTruckRouteScheduleError = state =>
  get(root(state), 'deleteTruckRouteScheduleError', null);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/managetruckrouteschedulelist/selectors.js